export default __webpack_public_path__ + "static/media/2gether.cb21aeeb.jpeg";